<template>
  <v-row no-gutters
    align="start"
    justify="center"
    class="multiview-browser-toolbar pl-12 secondary">
      <od-os-ou-buttons :eye="proofsheetEyeFilter" @selectEye="selectEyeProofsheet" />
      <reset-slider
        class="mx-1"
        :color="colorHex"
        :value="scale"
        :min="0.25"
        :max="1.85"
        :step="0.05"
        :defaultValue="0.5"
        @input="$emit('updateThumbnailSize', $event)"
        name="Thumbnail Size"/>
      <v-col cols="auto">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <image-button
              v-on="on"
              icon
              class="mx-1 select-button"
              :image="coloredAssetUrls.dropdown"/>
          </template>
          <v-list>
            <v-list-item
              v-for="item in filterOptions"
              :key="item"
              @click="selectFilterProofsheet(item)">{{item}}</v-list-item>
          </v-list>
        </v-menu>
        <span>View: {{this.proofsheetFilterOption}}</span>
      </v-col>
      <!-- Circular buttons  for other options -->
      <avatar-button 
        class="hidden-for-overlay"
        @click="openStereo(selectedProofsheetImages)" 
        :image="coloredAssetUrls.stereo">Stereo</avatar-button>
      <avatar-button
        class="hidden-for-overlay"
        @click="openSideBySide(selectedProofsheetImages)"
        :image="coloredAssetUrls.sideBySide">Side by Side</avatar-button>
      <avatar-button
        class="hidden-for-overlay"
        @click="openMontage(selectedProofsheetImages)"
        :image="coloredAssetUrls.montage">Montage</avatar-button>
      <avatar-button
        class="hidden-for-overlay"
        @click="openOverlay(selectedProofsheetImages)"
        :image="coloredAssetUrls.overlay">Overlay</avatar-button>
      <avatar-button
        class="hidden-for-overlay"
        v-if="!userIsViewOnly"
        @click="openPrintPreview(selectedProofsheetImages)"
        :image="coloredAssetUrls.printButton">Print</avatar-button>        
      <avatar-button 
        class="hidden-for-overlay"
        v-if="canDelete && (!ssoEmrPro || enableSavingWithEmrPro) && !userIsViewOnly"
        @click="startDeleteImages" 
        :image="coloredAssetUrls.removeImages">Delete Image(s)</avatar-button>      
      <avatar-button
        class="hidden-for-overlay"
        v-if="canDownload && !userIsViewOnly"
        @click="startDownloadImages" 
        :image="coloredAssetUrls.downloadCircle">Download Image(s)</avatar-button>
      <avatar-button 
        class="hidden-for-overlay"
        @click="startMarkImages" 
        :image="coloredAssetUrls.markImage"
        v-if="(!ssoEmrPro || enableSavingWithEmrPro) && !userIsViewOnly">Mark Image(s)</avatar-button>
      <avatar-button 
        class="inline-flex-for-overlay"
        @click="cancelAddImagesToOverlay" 
        :image="coloredAssetUrls.close">Cancel</avatar-button>
      <avatar-button 
        class="inline-flex-for-overlay"
        @click="openOverlay(selectedProofsheetImages)" 
        :image="coloredAssetUrls.returnToOverlay">Register Selected Image(s) and Return to Overlay</avatar-button>
    <v-tooltip right>
      <template v-slot:activator="{on}">
        <v-checkbox
          class="select-all-checkbox small-checkbox"
          :input-value="proofsheetAllSelected"
          :color="colorHex"
          hide-details
          v-on="on"
          @click.stop="selectAllProofsheet"/>
      </template>
      <span>Select/Deselect All Images</span>
    </v-tooltip>
  </v-row>
</template>

<script>
import resetSlider from "../controls/ResetSlider";
import imageButton from "../controls/ImageButton";
import avatarButton from "../controls/AvatarButton";
import odOsOuButtons from "../imageBrowser/controls/OdOsOuButtons";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "proofsheetModalToolbar",
  components: { imageButton, resetSlider, odOsOuButtons, avatarButton },
  props: ["scale"],
  data() {
    return {
      filterOptions: ["Only Selected Images", "All Images"]
    };
  },
  computed: {
    ...mapGetters([
      "patient",
      "ptSrNo",
      "eyeGroups",
      "currentGroup",
      "proofsheetEyeFilter",
      "proofsheetFilterOption",
      "proofsheetAllSelected",
      "selectedProofsheetImages",
      "canDelete",
      "canDownload",
      "ssoEmrPro",
      "userIsViewOnly",
      "enableSavingWithEmrPro"
    ])
  },
  methods: {
    ...mapActions([
      "selectAllProofsheet",
      "selectEyeProofsheet",
      "selectFilterProofsheet",
      "openStereo",
      "openSideBySide",
      "openPrintPreview",
      "openMontage",
      "openOverlay",
      "startDeleteImages",
      "startDownloadImages",
      "startMarkImages",
      "cancelAddImagesToOverlay"
    ]),
    ...mapMutations(["setPlaceholderContext"])
  }
};
</script>